/**
 * Field Path Context
 *
 * Provides path prefix to Field components so they can resolve their full
 * path for path-scoped enum lookups. Section components set the prefix
 * (e.g., "drug.coverage") and Field components read it to build the full
 * path (e.g., "drug.coverage.coinsurance").
 */

import React, { createContext, useContext } from 'react';

const FieldPathContext = createContext<string>('');

interface FieldPathProviderProps {
  prefix: string;
  children: React.ReactNode;
}

export const FieldPathProvider: React.FC<FieldPathProviderProps> = ({ prefix, children }) => (
  <FieldPathContext.Provider value={prefix}>{children}</FieldPathContext.Provider>
);

export function useFieldPath(): string {
  return useContext(FieldPathContext);
}
